import React, { Fragment } from 'react';
import { Row } from 'hedron';
import PropTypes from 'prop-types';
import { Desktop, Mobile } from '../MediaQuery';
import ShowDepartmentsDiv from './styled/ShowDepartmentsDiv';

const SearchDepartment = ({ children, showDepartments }) => (
  <Fragment>
    <Mobile>
      <Row justifyContent="space-around" style={{ marginTop: '10px' }}>
        {children}
      </Row>
    </Mobile>
    <Desktop>
      <ShowDepartmentsDiv showDepartments={showDepartments}>{children}</ShowDepartmentsDiv>
    </Desktop>
  </Fragment>
);

SearchDepartment.propTypes = {
  showDepartments: PropTypes.bool
};

export default SearchDepartment;
